import {
  filter,
  find,
  flatMap,
  get,
  isEmpty,
  map,
  toString,
  toNumber,
  range as _range,
  compact,
  difference,
  some,
  includes,
} from 'lodash'

import { KG_NODES, ValidationCategory as State } from '@common'

import { planSchema } from './schema'

function getSelectedTables(productFeeTables, feetables) {
  return map(feetables, feetable => ({
    ...feetable,
    ...find(productFeeTables, { _id: feetable.feetable_id }),
  }))
}

function computeValues({ list, range, type }) {
  return type === 'list' ? list : map(_range(...range), toString)
}

export const rules = [
  ({ request_variables, feetables }, { productFeeTables, variableKGNodes }) => {
    if (isEmpty(feetables)) return { result: [] }
    const selectedTables = getSelectedTables(productFeeTables, feetables)
    const result = flatMap(request_variables, ({ request_variable }, idx) =>
      flatMap(request_variable, variable => {
        const { request_type } = variable
        const { name: requestName, attributes } = find(variableKGNodes, {
          node_id: request_type,
        })
        const {
          values: [valueType],
        } = find(attributes, { name: 'type' })
        const values = computeValues({ ...variable, type: valueType })
        return compact(
          map(selectedTables, ({ name, factors }) => {
            const factorValues = get(
              find(factors, { id: request_type }),
              'values',
            )
            if (
              !isEmpty(factorValues) &&
              !isEmpty(difference(values, factorValues))
            ) {
              return [
                State.Error,
                `需求變數[${idx}]「${requestName}」未涵蓋於費率表「${name}」值域內`,
              ]
            }
          }),
        )
      }),
    )
    return {
      fieldname: planSchema.request_variables.label,
      result,
    }
  },
  ({ amount_options, feetables }, { productFeeTables }) => {
    const selectedTables = getSelectedTables(
      productFeeTables,
      filter(feetables, ({ feetable_id }) => {
        const feetable = find(productFeeTables, { _id: feetable_id })
        return (
          get(feetable, 'fee_base', 0) !== 0 &&
          get(feetable, 'currency_id') ===
            'channel_concept/5f85099dbbad8a45392bd382'
        )
      }),
    )

    const result = compact(
      map(selectedTables, ({ name, axes, fee_base }) => {
        const amount = find(axes, {
          axis_id: KG_NODES.insurance.REQUEST_VARIABLE.REQUEST_AMOUNT,
        })
        const value_type = get(amount, 'value_type')
        // 常數
        if (
          value_type === 'const' &&
          toNumber(get(amount, 'constant')) % fee_base !== 0
        )
          return [
            State.Warning,
            `費率表「${name}」保額對應輸入值應為投保額度(${fee_base})的倍數`,
          ]
        const option = find(amount_options, {
          option_id: get(amount, 'option_id'),
        })
        const planRatio = get(amount, 'plan_ratio', 1)
        // 對應保額選項
        if (value_type === 'id') {
          const values = map(computeValues(option), value =>
            toString(toNumber(value) * planRatio),
          )
          if (some(values, val => parseInt(val) % fee_base !== 0))
            return [
              State.Warning,
              `「${option.name}」保額選項的值(乘以倍率)應全部為投保額度(${fee_base})的倍數`,
            ]
        }
      }),
    )

    return {
      fieldname: planSchema.amount_options.label,
      result,
    }
  },
  ({ amount_options, feetables }, { productFeeTables }) => {
    const selectedTables = getSelectedTables(
      productFeeTables,
      filter(feetables, ({ feetable_id }) => {
        const { factors } = find(productFeeTables, { _id: feetable_id })
        return find(factors, {
          id: KG_NODES.insurance.REQUEST_VARIABLE.REQUEST_AMOUNT,
        })
      }),
    )
    const result = compact(
      map(selectedTables, ({ name, axes, factors }) => {
        const amount = find(axes, {
          axis_id: KG_NODES.insurance.REQUEST_VARIABLE.REQUEST_AMOUNT,
        })
        const value_type = get(amount, 'value_type')
        const requestAmount = find(factors, {
          id: KG_NODES.insurance.REQUEST_VARIABLE.REQUEST_AMOUNT,
        }).values
        if (
          value_type === 'const' &&
          !includes(requestAmount, toString(get(amount, 'constant')))
        )
          return [State.Error, `費率表「${name}」保額選項的值應列於投保額度內`]

        const option = find(amount_options, {
          option_id: get(amount, 'option_id'),
        })
        if (value_type === 'id') {
          const values = map(computeValues(option), value =>
            toString(toNumber(value) * get(amount, 'plan_ratio', 1)),
          )
          if (
            !isEmpty(
              difference(filter(values, value => value !== '0'), requestAmount),
            )
          )
            return [
              State.Error,
              `「${option.name}」保額選項的值(乘以倍率)應全部列於投保額度內`,
            ]
        }
      }),
    )

    return {
      fieldname: planSchema.amount_options.label,
      result,
    }
  },
]
